export default __webpack_public_path__ + "static/media/3_logo.3c02594c.png";